import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propFunc, propNumber } from '../../../../../helpers/custom-prop-types';
const PrevNav = ({ goBackStep, step }) => (_jsx("div", Object.assign({ className: 'prev-nav' }, { children: _jsx("button", Object.assign({ className: 'btn btn-primary btn-arrow-prev', onClick: () => goBackStep(step), type: 'button' }, { children: "\u524D\u3078\u623B\u308B" })) })));
PrevNav.propTypes = {
    goBackStep: propFunc().isRequired,
    step: propNumber().isRequired,
};
export default PrevNav;
